import { DateTime } from '~domain/model/core/date/datetime';
import { PolicySummaryFacade } from '~domain/model/facade/policy/policy-summary-facade';
import { policiesClient } from '~web-portal/clients/policies-client';
import { getUserAuth } from '~web-portal/helpers/get-user-auth';

export class PolicyService {
  /**
   * Fetch the list of all active policies for current user
   */
  async getPolicies(): Promise<PolicySummaryFacade[]> {
    const { userId, accessToken } = getUserAuth();
    const policies = await policiesClient.getPolicies(accessToken, {
      userAccountId: userId,
      expirationDateGreaterThanOrEqualTo: new DateTime().addDays(-90).clearTime(),
    });

    return policies.map((policy) => new PolicySummaryFacade(policy));
  }

  /**
   * Fetch a policy using its policy id
   */
  async getPolicy(policyId: string): Promise<PolicySummaryFacade> {
    const { accessToken } = getUserAuth();
    const policy = await policiesClient.getPolicy(accessToken, policyId);
    return new PolicySummaryFacade(policy);
  }
}

export const policyService = new PolicyService();
